import { render, staticRenderFns } from "./AsientosComponent.vue?vue&type=template&id=f64dd4e4"
import script from "./AsientosComponent.vue?vue&type=script&lang=js"
export * from "./AsientosComponent.vue?vue&type=script&lang=js"
import style0 from "./AsientosComponent.vue?vue&type=style&index=0&id=f64dd4e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports